import { createSlice } from '@reduxjs/toolkit';

import { getSurveys, getSurveysByStudentId } from './actions';

const initialState = {
  data: [] as any[],
  currentPage: 1,
  totalPages: null as any,
  perPage: 50,
};

const surveysSlice = createSlice({
  name: 'surveys',
  initialState,
  reducers: {},
  extraReducers: (builder: any) => {
    builder.addCase(getSurveys.fulfilled, (_: any, action: any) => {
      return action.payload;
    });

    builder.addCase(getSurveysByStudentId.fulfilled, (_: any, action: any) => {
      return action.payload;
    });
  },
});

export default surveysSlice.reducer;
